import { Component } from '@angular/core';
import { SessionService } from '../Util/Session/session.service';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonService } from '../Model/Common/common.service';
import { CommonModule } from '@angular/common';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomDateParserFormatter } from '../Util/DateFormat/date-format.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-employee-termination-form',
  standalone: true,
  imports: [FormsModule, RouterModule, CommonModule, NgbModule, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './employee-termination-form.component.html',
  styleUrl: './employee-termination-form.component.scss'
})
export class EmployeeTerminationFormComponent {

  user: any;
  isApproval: boolean = false;
  isTermination: boolean = false;
  ReasonLoad: any[] = [];

  constructor(
    private session: SessionService,
    public common: CommonService,
    private router: Router
  ) {
    this.isApproval = router.url.includes('resignationapproval');
    this.isTermination = router.url.includes('manualtermination');
    this.user = session.GetUserDetails();
  }

  ngOnInit() {
    this.employee.empCode = this.user.EmpCode;
    this.employee.empName = this.user.UserName;
    this.employee.requestedDate = this.user.Date;
    this.employee.requestedDate = new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric', });
  }

  employee = {
    empCode: '',
    empName: '',
    designation: 'Developer',
    requestedDate: '',
    noticePeriod: '60 Days',
    lastWorkingDay: '',
    reportingManager: 'Ravi Maskar',
    photo: '',
    location: 'Andheri | LIC | Marol Naka'
  };

  form = {
    proposedLastWorkingDay: '',
    acceptedLastWorkingDay: '',
    reason: null,
    remark: '',
    terminationType: ''
  };

  onSubmit(form: any) {
    if (form.valid) {
      const payload = {
        ...this.employee,
        ...this.form
      };
      console.log(payload);
      alert('Resignation Submitted Successfully');
    }else{
      form.submitted = true;
    }
  }
}
